module.exports = __webpack_public_path__ + "static/media/design-big.21eb1b72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/design-big.jpg
// module id = 134
// module chunks = 0